module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.570eb838.woff2";